import React from 'react';
import { useBranding } from '../../hooks/useBranding';

const HERO_IMAGE_PATH = '/td-home/images/landingpage/hero/hero-image';
const HERO_IMAGE_PATH_HUG = '/td-home/images/landingpage/hero/hug/hero-image';

export const HeroImage = () => {
  const branding = useBranding();
  const imagePath = branding === 'hug' ? HERO_IMAGE_PATH_HUG : HERO_IMAGE_PATH;

  return (
    <div className="bg-img-container" style={{ width: '100%' }}>
      <img
        src={`${imagePath}-default.png`} // Fallback image
        srcSet={`
          ${imagePath}-sm.png 834w,
          ${imagePath}-xxl.png 1280w,
          ${imagePath}-xxl.png 1900w,
          ${imagePath}-xxxl-2x.png 3800w
        `}
        sizes="(min-width: 1900px) 1900px, (min-width: 1280px) 1280px, (min-width: 834px) 834px, 100vw"
        alt="Hero image description"
        loading="lazy"
        decoding="async"
        className="hero-image"
      />
    </div>
  );
};
